import"tslib";import"@tencentcloud/chat-uikit-engine";import"react";import"../utils/env.js";window.tencent_cloud_im_csig_react_uikit_23F_xa=!0;
